import { render, staticRenderFns } from "./Memorygame.vue?vue&type=template&id=29b9650c&"
import script from "./Memorygame.vue?vue&type=script&lang=js&"
export * from "./Memorygame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports